import { Stack } from "@mui/material";
import { Text, Tooltip } from "@src/flat-ui";

interface Props {
  /** Measurement value */
  value: string;

  /** Tooltip text to show on hover */
  tooltip: string;

  /** Icon to display alongside the measurement value */
  icon: JSX.Element;
}

/**
 * Renders an annotation measurement value
 */
export function MarkupMeasurement({
  value,
  tooltip,
  icon,
}: Props): JSX.Element {
  return (
    <Stack
      sx={{
        flexDirection: "row",
        alignItems: "center",
        gap: 2,
      }}
    >
      <Tooltip title={tooltip}>{icon}</Tooltip>
      <Text variant="bodyS" component="var">
        {value}
      </Text>
    </Stack>
  );
}
